<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="default" color="#7bff76" type="square-loader" [fullScreen]="false">
    <p style="color: white"> Loading... </p>
</ngx-spinner>
<div class="content-wrapper">
    <!-- ส่วนของ หัวหน้าส่วน -->
    <div class="card" [hidden]="access==2">
        <div class="card-header bg-primary">
            <h3><i class="fas fa-clipboard-list"></i> ขอยืมคิวข้ามกลุ่ม</h3>
        </div>

        <div class="card-body">
            <!-- <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <label class="input-group-text" for="Grouptype">ประเภทกลุ่ม</label>
                </div>
                <select class="custom-select" id="Grouptype" [(ngModel)]="qTypeL" (ngModelChange)="change_Q()">
                    <option value="" disabled>เลือกประเภทคิว </option>
                    <option value="1">คิวล็อก</option>
                    <option value="2">คิวรถโยน</option>
                    <option value="3">คิวรถตัด</option>
                </select>
                <span class="input-group-text" id="basic-addon1">เลือก กลุ่มเดิม</span>
                
            <select class="form-select" id="mygroup" [(ngModel)]="sgroup[1]" (ngModelChange)="change_Q()">
                <option [ngValue]="" disabled>เลือกกลุ่มคิว </option>
                <option *ngFor="let item of listgroup" [ngValue]="item.groupcode">{{item.groupcode}}</option>
            </select>
            <span class="input-group-text">เลือกคิวรอบที่ต้องการย้าย</span>
            <select class="form-select" [(ngModel)]="sloop[1]">
                <option *ngFor="let item of loopQSl" [ngValue]="item.loop_id">รอบที่ {{item.loop_id}} </option>
            </select>
            <select class="form-select" [(ngModel)]="sloop[2]">
                <option *ngFor="let item of loopQSl" [ngValue]="item.loop_id">รอบที่ {{item.loop_id}} </option>
            </select>
            <button class="btn btn-info" (click)="LoadQueueinGroup();">ค้นหา</button>
            </div>-->
            <div class="row">
                <div class="col-md-2">
                    <mat-form-field appearance="fill">
                        <mat-label>ประเภทกลุ่ม</mat-label>
                        <mat-select required [(ngModel)]="qTypeL" (selectionChange)="change_Q()">
                            <mat-option value="1">คิวล็อก</mat-option>
                            <mat-option value="2">คิวรถโยน</mat-option>
                            <mat-option value="3">คิวรถตัด</mat-option>
                        </mat-select>
                    </mat-form-field>

                </div>
                <div class="col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>เลือก กลุ่มที่จะย้าย</mat-label>
                        <mat-select required [(ngModel)]="sgroup[1]" (ngModelChange)="change_Q()" [disabled]="">
                            <mat-form-field class="example-form-field" appearance="fill">
                                <mat-label>ค้นหา -*กลุ่มตัด-</mat-label>
                                <input matInput type="text" style="text-align:center" [(ngModel)]="txtSearch[0]">
                                <button *ngIf="txtSearch[0]" matSuffix mat-icon-button aria-label="Clear"
                                    (click)="txtSearch[0]=''"><mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                            <mat-option *ngFor="let item of listgroup | filter:txtSearch[0]"
                                [value]="item">{{item.groupcode}}-{{item.h_fmname}}</mat-option>
                        </mat-select>
                        <mat-hint>{{sgroup[1].groupcode}}</mat-hint>
                    </mat-form-field>
                </div>
                <div class="col-md-auto">
                    <mat-form-field appearance="fill">
                        <mat-label>เลือกรอบเริ่มต้น</mat-label>
                        <mat-select required [(ngModel)]="sloop[1]">
                            <mat-option *ngFor="let item of loopQSl" [value]="item.loop_id">รอบที่ {{item.loop_id}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-auto">
                    <mat-form-field appearance="fill">
                        <mat-label>ถึงรอบ</mat-label>
                        <mat-select required [(ngModel)]="sloop[2]">
                            <mat-option *ngFor="let item of loopQSl" [value]="item.loop_id">รอบที่ {{item.loop_id}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md">
                    <button class="btn btn-info" (click)="LoadQueueinGroup();">ค้นหา</button>
                </div>
            </div>
            <!--<button *ngFor="let item of datagroupinpart" class="btn btn-sm btn-warning"
                    (click)="SelectList(item.loop_id,item.q_id);">&nbsp;{{item.q_id}}&nbsp;</button>
                -->

            <div *ngIf="datagroupinpart.length > 0">
                <!--
                <div class="btn-group mr-2" role="group" aria-label="Basic example"
                    *ngFor="let item of datagroupinpart">
                    <button type="button" class="btn btn-outline-danger btn-sm"
                        (click)="SelectList(item.loop_id,item.q_id);">{{item.q_id}}</button>
                </div>
                <div *ngFor="let item2 of datagroupinpart">
                    <mat-checkbox [(ngModel)]="item2.selected">{{item2.q_id}}
                    </mat-checkbox>
                </div>
                -->
                <!--
                <span class="border border-primary">
                    <div class="checkbox-container">
                        <mat-checkbox *ngFor="let item of datagroupinpart" [checked]="item.selected"
                            (change)="onCheckboxChange(item.q_id, $event.checked)">
                            {{ item.q_id }}&nbsp;&nbsp;,&nbsp;
                        </mat-checkbox>
                    </div>
                </span>-->

                <div class="grid-container">
                    <div class="grid-item" *ngFor="let item of datagroupinpart">
                        <!--<span>{{ item.q_id }}</span>
                        <input type="checkbox" [checked]="item.checked" (change)="item.checked = !item.checked">
                        -->
                        <mat-checkbox [checked]="item.selected" (change)="onCheckboxChange(item.q_id, $event.checked)">
                            {{ item.truck_type }}{{ item.q_id }}
                        </mat-checkbox>
                    </div>
                </div>
                <!--<table mat-table [dataSource]="dataSourceMat" class="mat-elevation-z8">
                    <ng-container matColumnDef="value">
                        <th mat-header-cell *matHeaderCellDef> Value </th>
                        <td mat-cell *matCellDef="let element"> {{element.q_id}} </td>
                    </ng-container>
                    <ng-container matColumnDef="selected">
                        <th mat-header-cell *matHeaderCellDef> Selected </th>
                        <td mat-cell *matCellDef="let element">
                            <mat-checkbox [(ngModel)]="element.selected"></mat-checkbox>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>-->
            </div>

            <hr>
            <div class="row">
                <div class="col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>โอนให้ กลุ่มใหม่</mat-label>
                        <mat-select required [(ngModel)]="sgroup[2]" [disabled]="">
                            <mat-form-field class="example-form-field" appearance="fill">
                                <mat-label>ค้นหา -*กลุ่มตัด-</mat-label>
                                <input matInput type="text" style="text-align:center" [(ngModel)]="txtSearch[1]">
                                <button *ngIf="txtSearch[1]" matSuffix mat-icon-button aria-label="Clear"
                                    (click)="txtSearch[1]=''"><mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                            <mat-option *ngFor="let item of allGroup | filter:txtSearch[1]"
                                [value]="item">{{item.groupcode}}-{{item.h_fmname}}</mat-option>
                        </mat-select>
                        <mat-hint>{{sgroup[2].groupcode}}</mat-hint>
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-form-field class="example-full-width" appearance="fill">
                        <mat-label>หมายเหตุ</mat-label>
                        <textarea matInput placeholder="ระบเหตุผล..." [(ngModel)]="sgroup[0]" id="comment_q"></textarea>
                    </mat-form-field>
                </div>
                <div class="col-md-2">
                    <div class="input-group mb-3">
                        <button class="btn btn-primary btn-sm" (click)="CheckLoopQueue();"
                            [disabled]="forwardlist.length == 0 || !sgroup[2]">ตรวจสอบคิวก่อนย้าย</button>
                    </div>
                </div>

            </div>
            <!--<div class="input-group mb-3">
                <span class="input-group-text" id="basic-addon1">โอนให้ กลุ่มใหม่</span>
                <select class="form-select" id="mygroup" [(ngModel)]="sgroup[2]">
                    <option value="">เลือกลุ่มที่จะรับคิว</option>
                    <option *ngFor="let item of allGroup" [ngValue]="item.groupcode">
                        {{item.groupcode}}-{{item.groupname}}</option>
                </select>
                <span class="input-group-text" id="basic-addon1">หมายเหตุ</span>
                <input type="text" class="form-control" [(ngModel)]="sgroup[0]">
            </div>-->

        </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="QueueChange" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">คิวที่เลือกไว้
                        <span class="badge text-bg-secondary">{{listqueue.length}}</span>
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="CloseModal();"
                        aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <table class="table table-bordered border-primary">
                        <thead>
                            <tr style="text-align: center;">
                                <th>คิว</th>
                                <th>รอบ</th>
                                <th>ประเภทคิว</th>
                                <th>กลุ่มเก่า</th>
                                <th>โซน</th>
                                <th>กลุ่มใหม่</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of listqueue" style="text-align: center;">
                                <td>{{item.truck_type}}.{{item.q_id}}</td>
                                <td>{{item.loop_id}}</td>
                                <td>{{item.bqdesc}}</td>
                                <td>{{item.groupcode}}</td>
                                <td>{{item.supzone}}</td>
                                <td>{{item.g2}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="CloseModal();">Close</button>
                    <button type="button" class="btn btn-primary" (click)="UpdateSelectQueueV5();">บันทึกคำขอ</button>
                </div>
            </div>
        </div>
    </div>

    <div class="card" [hidden]="access==2">
        <div class="card-header">รายการคำขอย้ายของฉัน</div>
        <div class="card-body">
            <div class="card-body table-responsive p-2" style="height: 600px">
                <table class="table table-hover table-head-fixed table-bordered border-primary">
                    <thead>
                        <tr style="text-align: center;">
                            <th>วันที่</th>
                            <th>จากกลุ่ม</th>
                            <th>ไปยังกลุ่ม</th>

                            <th>รอบ</th>
                            <th>ประเภทคิว</th>
                            <th>คิวที่ย้าย</th>
                            <th>หมายเหตุ</th>
                            <th>สถานะ</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of inpathdata">
                            <td>{{item.dateadd_th}}</td>
                            <td>{{item.from_groupcode}}</td>
                            <td>{{item.to_groupcode}}</td>

                            <td>จากรอบ {{item.start_loop}} ไปรอบ {{item.end_loop}}</td>
                            <td>{{item.qdesc}}</td>
                            <td>{{item.q_idj|json}}</td>
                            <td>{{item.comment}}</td>
                            <td>{{item.status_desc}}</td>
                            <!-- <td *ngIf="item.status==0">
                            <button class="btn btn-success btn-sm" (click)="AcceptAsk(item.id)"> <i class="fas fa-check"></i> อนุมัติ</button>
                        </td> -->
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>